//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUpload from '@/components/file-upload'
import DivSpan from '@/components/DivSpan'

export default {
  name: "pur-requisition-check",

  components: {
    fileUpload,
    DivSpan,
  },
  props: ['dataId','dataImg'],
  data() {
    return {
      type: "",
      typeJson: {},
      baseDto: {},
      baseList: [],
      payList: [{name:'收入'},{name:'支出'}],
      showMore: true,
      showFixed: false,
      bigImg:false,
      index: 1,
      baseInfoIndex: 1,
      gridList: [
        {icon:require('@/assets/icon/supplier/supplier_base_data.png'),label:'表单'},
        {icon:require('@/assets/icon/supplier/bidding_detail.png'),label:'审批表'},
        {icon:require('@/assets/icon/supplier/com_order_flow.png'),label:'流程信息'},
      ],
    }
  },
  methods: {
    changeCellShow(list,i){
      if(list[i].cellShow){
        this.$set(list[i],'cellShow',false);
        return;
      }
      this.$set(list[i],'cellShow',true);
    },
    statusClick(code) {
      this.baseInfoIndex = code
    },
    itemTab(index) {
      this.index = index;
      if(index === 3){
        this.$emit('changeFlowInfo',true);
      }else{
        this.$emit('changeFlowInfo',false);
      }
    },

    changeShow(i) {
      if (this.baseList[i].showContent) {
        this.$set(this.baseList[i], 'showContent', false);
        return;
      }
      this.$set(this.baseList[i], 'showContent', true);
    },
    //检查是否为固定资产审批表
    checkFixed(){
      if(this.baseDto.typeCode === 'zaijian' || this.baseDto.typeCode ==='guding_equipment'||
        this.baseDto.typeCode === 'guding_bg'){
        this.showFixed = true;
      }else{
        this.showFixed = false;
        this.$set(this.gridList[1],'show',true)
      }
    },
    getbaseDto() {
      this.$loadingShow();
      this.$get('api/purRequisitionMat/' + this.dataId).then((data) => {
        if (data) {
          this.baseDto = data;
          this.baseList = data.purRequisitions;
          this.checkFixed();
          this.baseDto.itemTypeName || this.getTypeList();
        }
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    valid(){
      return true;
    },
    formData(){
      return this.baseDto;
    },
    getTypeList(){
      this.$get("api/pur-requisition-type").then(data =>{

        data.forEach(item =>{
          this.typeJson[item.code] = item.value
        });
        this.type = this.typeJson[this.baseDto.itemType]
        console.log("this.baseDto", this.baseDto)
      })
    }
  },
  mounted() {
    if (this.dataId) {
      this.getbaseDto()
    };
  },
  watch: {
    dataId() {
      if (this.dataId) {
        this.getbaseDto()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/purchase-requisition/pur-requisition-check.vue